import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

export default class extends Component {
  static propTypes = {
    options: PropTypes.array.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func
  }

  onChange = value => {
    this.props.onChange && this.props.onChange(value)
  }

  renderOption = option => {
    const checked = this.props.value === option.value

    return <div className={cn('select-tile-tile', {active: checked})} key={option.value}>
      <label>
        <input className='tile-input' type='radio'
          checked={checked} onChange={this.onChange.bind(this, option.value)} value={option.value}
        />
        <span className='tile-caption'>{option.text}</span>
      </label>
    </div>
  }

  render () {
    const {options} = this.props

    return <div className='select-tile'>
      {(options || []).map(this.renderOption)}
    </div>
  }
}



// WEBPACK FOOTER //
// ./app/components/fields/SelectTile.js